import React from "react";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/ham_cheese_croissant_sandwich_1200x900.png";
import { Helmet } from "react-helmet-async";
import useMetaTracking from "../hooks/useMetaTracking";

function HamCheeseCroissantSandwich() {
  useMetaTracking("ViewContent", {
    content_name: "Ham & Cheese Croissant Sandwich",
    content_category: "Regular Menu",
    content_ids: ["ham_cheese_croissant_sandwich"],
    content_type: "bánh mì",
    value: 7.50,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Ham & Cheese Croissant Sandwich | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Classic croissant sandwich made with deli ham, cheese, pâté, tomato, salad, cilantro, jalapeño."
        />
        <meta property="og:title" content="Ham & Cheese Croissant Sandwich | Đông Hưng Viên Bakery" />
        <meta
          property="og:description"
          content="Classic croissant sandwich made with deli ham, cheese, pâté, tomato, salad, cilantro, jalapeño."
        />
        <meta property="og:image" content={CardImg} />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f", color: "#fff" }}>
        <ProductCard
          cardImg={CardImg}
          titleHead="Ham & Cheese Croissant Sandwich"
          titleSubHead="$7.50 each"
          detailBodyBr="Classic croissant sandwich made with deli ham, cheese, pâté, tomato, salad, cilantro, jalapeño."
          detailBody3="Contains: wheat, dairy, egg"
          ProductCardBtn="View Full Regular Menu"
          btnLink="/regular-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default HamCheeseCroissantSandwich;
